import type { ButtonHTMLAttributes } from "react";
import { cn } from "../lib/cn.ts";

export type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** @default "md" */
  size?: "sm" | "md";
};

export function IconButton({
  size = "md",
  className,
  type = "button",
  ...props
}: IconButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        "inline-flex items-center justify-center rounded-lg lg:rounded-[var(--sf-radius)] border-none",
        "bg-transparent text-[var(--sf-text-muted)] font-[inherit] transition-colors",
        "hover:bg-[var(--sf-surface-2)]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--sf-primary)] focus-visible:ring-offset-2",
        "disabled:pointer-events-none disabled:opacity-50",
        size === "sm"
          ? "h-8 w-8 lg:h-5 lg:w-5"
          : "h-10 w-10 lg:h-[30px] lg:w-[30px]",
        className,
      )}
      {...props}
    />
  );
}
